export const enum OrderPaymentTypeEnum {
    BANK_TRANSFER = 'bank_transfer',
    CASH = 'cash',
    CARD_ONLINE = 'card_online',
    CASH_ON_DELIVERY = 'cash_on_delivery',
    INSTALLMENTS = 'installments',
}